import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import {PhoneGradingDeductionComponent} from './PhoneGradingDeduction.component'
import { RouterModule } from '@angular/router';
import { TooltipModule } from 'ng2-tooltip-directive';
import { MatInputModule, MatPaginatorModule, MatProgressSpinnerModule,
  MatSortModule, MatTableModule } from "@angular/material";
  import { UiSwitchModule } from 'ngx-ui-switch';
  import { MyDatePickerModule } from 'mydatepicker';
  import { HttpClientModule } from '@angular/common/http';
const routerConfig = [{
  path: '',
  component: PhoneGradingDeductionComponent
}];

@NgModule({
  imports: [
    CommonModule ,FormsModule ,TooltipModule,  MyDatePickerModule,
     MatTableModule ,MatSortModule,MatInputModule, MatPaginatorModule, MatProgressSpinnerModule,ReactiveFormsModule,
    RouterModule.forChild(routerConfig),
    UiSwitchModule,HttpClientModule
  ] ,
  declarations: [
    PhoneGradingDeductionComponent
    //TruncatePipe
  ],
  exports: [
    PhoneGradingDeductionComponent ,MatSortModule
  ],
  providers: []

})

export class PhoneGradingDeductionModule { }
